import React from "react";

const PhotoGridComponent = ({ text }) => {
  return (
    <div className="photos-container">
      <div className="big-container image1">
        <img src={require("./res/sketch.jpg")} alt="cat" />
      </div>
      <div className="half-container image2">
        <img src={require("./res/bts (9).jpg")} alt="cat" />
      </div>
      <div className="half-container image3">
        <img src={require("./res/bts (14).jpg")} alt="cat" />
      </div>

      <style jsx>{`
        .photos-container {
          margin: 5em 0em;
          display: grid;
          width: 100%;
          max-width: 100%;
          grid-template-columns: auto auto;
          gap: 10px; /* Adjust gap between items as needed */
        }

        .big-container {
          width: 100%;
          height: 100dvh;
          display: flex;
        }

        .big-container img {
          object-fit: contain;
          max-width: 90%;
          height: 100%;
          margin: auto;
          align-self: center;
        }

        .half-container {
          height: 80dvh;
          max-width: 50%;
          display: flex;
          margin: auto;
        }

        @media (max-width: 768px) {
          .big-container {
            height: auto;
          }

          .big-container img {
            height: auto;
          }

          .half-container {
            max-width: 45%;
            margin: 5px;
          }
        }

        .half-container img {
          object-fit: contain;
          width: 45dvw;
          height: 80%;
          align-self: center;
          margin: auto;
        }

        .image1 {
          grid-column-start: 1;
          grid-column-end: 3;
          max-width: 100%;
        }
      `}</style>
    </div>
  );
};

export default PhotoGridComponent;
